
class MkPasswd {

	constructor (){
		this.availableCharacters = [
			"upper",
			"lower",
			"number",
			"symbol"
		];

		this.options = {
			length: 8,
			count: 16,
			except: "0",
			additional: "",
			character: this.availableCharacters
		};
	}

	getCharacterSet (){
		var set = "",
			src = this.options.character,
			alpha = "abcdefghijklmnopqrstuvwxyz",
			number = "0123456789",
			symbol = "#$%&-=?@[]_";

		if(src.indexOf("upper") >= 0){
			set += alpha.toUpperCase();
		}
		if(src.indexOf("lower") >= 0){
			set += alpha;
		}
		if(src.indexOf("number") >= 0){
			set += number;
		}
		if(src.indexOf("symbol") >= 0){
			set += symbol;
		}

		set = Array.from(set);

		// additionals
		if(this.options.additional){
			set = set.concat(Array.from(this.options.additional));
		}

		// exceptions
		set = set.filter((char) => {
			return this.options.except.indexOf(char) < 0;
		});

		return _.uniq(set);
	}

	config (options){
		$.extend(this.options, options);
	}


	generate (){
		var chars = this.getCharacterSet(),
			list = [];

		$.times(this.options.count, () => {
			var pswd = "";
			$.times(this.options.length, () => {
				var c = $.randomFrom(chars);
				pswd += c;
			});
			list.push(pswd);
		});

		return list;
	}

}

const mkPasswd = new MkPasswd();

export default mkPasswd;



// WEBPACK FOOTER //
// ./src/js/lib/mkpasswd.js